"use strict";
/*
 * Created on 11 21 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SimilarProduct_1 = require("../model/SimilarProduct");

var SimilarProductConverter_1 = require("./SimilarProductConverter");
/**
 * @author VRu
 * @author Jan Gregor (moved from data pump)
 */


var SimilarProductConverterImpl =
/*#__PURE__*/
function (_SimilarProductConver) {
  _inherits(SimilarProductConverterImpl, _SimilarProductConver);

  function SimilarProductConverterImpl() {
    _classCallCheck(this, SimilarProductConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimilarProductConverterImpl).apply(this, arguments));
  }

  _createClass(SimilarProductConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        siteId: conversions.toDocumentReferenceId(source.siteId),
        productId: conversions.toDocumentReferenceId(source.productId),
        similarProductId: conversions.toDocumentReferenceId(source.similarProductId),
        processed: source.processed
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SimilarProduct_1.SimilarProduct(SimilarProduct_1.SimilarProduct.schema.id.valueOf(conversions.documentToClassId(source)), SimilarProduct_1.SimilarProduct.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), SimilarProduct_1.SimilarProduct.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), SimilarProduct_1.SimilarProduct.schema.similarProductId.valueOf(conversions.toClassReferenceId(source.similarProductId)), SimilarProduct_1.SimilarProduct.schema.processed.valueOfField(source));
    }
  }]);

  return SimilarProductConverterImpl;
}(SimilarProductConverter_1.SimilarProductConverter);

exports.SimilarProductConverterImpl = SimilarProductConverterImpl;